import styled from 'styled-components';
import DatePicker from 'react-datepicker';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const InputDate = styled(DatePicker)`
  width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 4px;
  color: #dee2e6;
  background: #323a4e;
  padding: 15px 5px;
  padding-left: ${p => (p.icon ? '2.5rem' : '1.6rem')};
  margin: 5px 0;
`;

export const Label = styled.div`
  margin: 20px 0;
  p {
    margin-bottom: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
  }
`;
